var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"method-container"},[_c('h5',[_vm._v("setTabActiveHandler")]),_c('pre',[_vm._v("      "),_c('code',[_vm._v("\n        tabActiveHandler(){\n          this.$router.replace({\n            name: 'HomeView'\n          })\n        }\n      ")]),_vm._v("\n    ")])])])
}]

export { render, staticRenderFns }